module.exports = __webpack_public_path__ + "static/media/agent-man.b646280b.png";